import React from "react";
import Loading from "../../../components/Loading/Loading";
import "./PayByMeSuccessPage.scss";

const PayByMeSuccessPage = () => {

  return (
    <div id="pay-by-me-success-page" className="page">
      <Loading className="white pt-0" fontSize={80} />
      <span className="title">İşleminiz devam ediyor,<br />tamamlandığında yönlendirileceksiniz.</span>
    </div>
  );
}

export default PayByMeSuccessPage;
